<!--
    描述：专家预约记录详情
    日期：2021/01/20
    作者：zwh
-->
<template>
  <div class="Apage operation-layout">
    <div>
      <div style="line-height:40px">
        <el-row>
          <el-col class="text-overflow" :span="8"
            >预约流水号：{{ detail.sysNo }}</el-col
          >
          <el-col class="text-overflow" :span="8"
            >预约时间：{{ detail.createDate }}</el-col
          >
          <el-col class="text-overflow" :span="6"
            >预约状态：
            <span
              style="color:red;"
              class="font16"
              v-if="detail.meetingStatus === 0"
              >预约中</span
            >
            <span
              style="color:blue;"
              class="font16"
              v-if="detail.meetingStatus === 1"
              >占用中</span
            >
            <span
              style="color:#3B9A00;"
              class="font16"
              v-if="detail.meetingStatus === 2"
              >已结束</span
            >
          </el-col>
        </el-row>
        <el-row>
          <el-col class="text-overflow" :span="8"
            >会议室名称：{{ detail.meetingName }}</el-col
          >
          <el-col class="text-overflow" :span="8"
            >归属场地：{{ detail.ascriptionName }}</el-col
          >
        </el-row>
        <el-row>
          <el-col class="text-overflow text-indent-1" :span="8"
            >项目名称：{{ detail.projectName }}</el-col
          >
          <el-col class="text-overflow" :span="8"
            >预约单位：{{ detail.companyName }}</el-col
          >
        </el-row>
        <el-row>
          <el-col class="text-overflow text-indent-2" :span="8"
            >预约人：{{ detail.userName }}</el-col
          >
          <el-col class="text-overflow" :span="8"
            >占用时间：{{ detail.occupancyTime }}</el-col
          >
        </el-row>
        <el-row>
          <el-col class="text-overflow text-indent-1" :span="8"
            >预约来源：<span class="font16" v-if="detail.sysCode === 1001"
              >能工社运营管理平台</span
            >
            <span class="font16" v-if="detail.sysCode == 1002"
              >能工社公共交易平台</span
            >
            <span class="font16" v-if="detail.sysCode == 1003"
              >安招采业务系统</span
            >
            <span class="font16" v-if="detail.sysCode == 1004"
              >专家评审项目</span
            >
            <span class="font16" v-if="detail.sysCode == 1005"
              >资源价格系统</span
            >
            <span class="font16" v-if="detail.sysCode == 1016007"
              >实施作业系统</span
            >
            <span class="font16" v-if="detail.sysCode == 1021002"
              >经营作业系统</span
            >
          </el-col>
          <el-col class="text-overflow" :span="8"
            >业务编号：{{ detail.aid }}</el-col
          >
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getExpertsRecordsReplyDetail,
  getExpertsReplyPageList,
  getRuleInfoByRuleId,
} from "api/modules/expertsRecordsReply";
export default {
  name: "",
  components: {},
  props: {
    detail: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      loading: false,
      objectItem: {},
      tableObj: {
        data: [],
        currentPage: 1, // 当前页码
        pageList: [10, 20, 50, 100], // 显示条数数组
        pageSize: 10, // 当前显示条数
        total: 0, // 当前总条数
      },
      ruleDialog: {
        show: false,
        ruleObjectItem: {},
      },
    };
  },
  mounted() {},
  computed: {
    applyId() {
      return this.$route.query.id;
    },
  },
  watch: {},
  created() {},
  methods: {
    getDetailInfo() {
      let param = {
        id: this.applyId,
      };
      getExpertsRecordsReplyDetail(param)
        .then((res) => {
          this.objectItem = res.data;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    getDetailExpertInfo() {
      let param = {
        current: this.tableObj.currentPage,
        size: this.tableObj.pageSize,
        applyId: this.applyId,
      };
      getExpertsReplyPageList(param)
        .then((res) => {
          this.tableObj.data = res.data.records;
          this.tableObj.currentPage = parseInt(res.data.current);
          this.tableObj.total = parseInt(res.data.total);
          this.tableObj.pageSize = parseInt(res.data.size);
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    ruleDialogShow() {
      this.ruleDialog.show = true;
      this.ruleDialog.ruleObjectItem = {};
      this.getRuleInfo();
    },
    getRuleInfo(row) {
      let param = {
        id: row.ruleId,
      };
      getRuleInfoByRuleId(param)
        .then((res) => {
          this.ruleDialog.ruleObjectItem = res.data;
        })
        .catch((err) => {});
    },
    voicePlay(row) {
      window.speechSynthesis.speak(row.noticeInfo);
      /*
            const url = "http://tts.baidu.com/text2audio?lan=zh&ie=UTF-8&text=" + encodeURI(row.noticeInfo);
            const audio = new Audio(url);
            audio.src = url;
            audio.play();
            return audio;
            */
    },
    ruleDialogClose() {
      this.ruleDialog.show = false;
    },
    // 切换显示条数
    handleSizeChange(val) {
      this.tableObj.pageSize = val;
      this.getTablePageList();
    },

    //切换当前页码
    handleCurrentChange(val) {
      this.tableObj.currentPage = val;
      this.getTablePageList();
    },
    // 返回
    goBack() {
      this.$router.push({ path: "/experts-records-reply" });
    },
  },
};
</script>
<style lang="less">
.Apage {
  .top-area {
    .text-overflow {
      text-align: right;
      color: #666;
      font-size: 14px;
    }
    .text-overflow-text {
      color: #666;
      font-size: 14px;
    }
  }
}
</style>

<style lang="less" scoped>
.text-indent-1 {
  text-indent: 1em;
}
.text-indent-2 {
  text-indent: 2em;
}
.font16 {
  font-weight: bold;
  font-size: 16px;
}
</style>
